import { render, staticRenderFns } from "./Nested-draggable.vue?vue&type=template&id=2acaf1e4&scoped=true"
import script from "./Nested-draggable.vue?vue&type=script&lang=js"
export * from "./Nested-draggable.vue?vue&type=script&lang=js"
import style0 from "./Nested-draggable.vue?vue&type=style&index=0&id=2acaf1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acaf1e4",
  null
  
)

export default component.exports